declare global {
  interface Window {
    ClassicEditor: any;
  }
}

import React, { useRef, forwardRef, useImperativeHandle, useEffect, useState } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
const WebEditor = forwardRef(
  (
    {
      defaultValue,
      value,
      onEditorChange,
    }: {
      defaultValue?: string;
      value?: string;
      onEditorChange: (value?: string) => void;
    },
    ref,
  ) => {
    const editorConfiguration = {
      extraPlugins: [
        function (editor: any) {
          editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
            return uploadImageHandler(loader);
          };
        },
      ],
    };

    const editorRef = useRef<any>(null);
    const [isInitialized, setIsInitialized] = useState(false);

    useImperativeHandle(ref, () => ({
      getData,
      setData,
    }));

    const getData = () => {
      if (editorRef.current.editor) return editorRef.current.editor.getData();
    };

    const setData = (data: string) => {
      if (editorRef.current?.editor) return editorRef.current.editor.setData(data);
    };

    const uploadImageHandler = (loader: any) => {
      return {
        upload() {
          return new Promise((resolve, reject) => {
            loader.file.then(async (file: any) => {
              // const data: any = await resourceStore.uploadFile(file);
              // resolve({ default: data.publicUrl });
            });
          });
        },
      };
    };

    useEffect(() => {
      if (defaultValue) {
        setTimeout(() => {
          setData(defaultValue);
          setIsInitialized(true);
        }, 100);
      }
    }, [defaultValue]);

    useEffect(() => {
      if (value !== undefined) {
        setData(value);
      }
    }, [value]);

    return (
      <CKEditor
        ref={editorRef}
        editor={window.ClassicEditor}
        config={editorConfiguration}
        data={typeof value !== 'undefined' ? value : ''}
        onReady={(editor: any) => { }}
        onChange={(event: any, editor: any) => {
          // if (!isInitialized) return;

          const data = editor.getData();
          if (onEditorChange) onEditorChange(data);
        }}
        onBlur={(event: any, editor: any) => { }}
        onFocus={(event: any, editor: any) => { }}
      />
    );
  },
);

WebEditor.displayName = 'WebEditor';
export default React.memo(WebEditor);
